import { useState, useEffect } from 'react'
import { get } from '../api'

export const useFetchDataById = ({ path, id }) => {
  const [data, setData] = useState()

  const fetchData = async () => {
    try {
      const { data } = await get({ path })
      setData(data)
    } catch (error) {
      console.log('useFetchData error', error)
    }
  }

  useEffect(() => {
    if (id && id !== 'new') fetchData()
  }, [id])

  return [data, setData, fetchData]
}